module.exports = __webpack_public_path__ + "b5d6046c76ae05521c4de79e6058fdbc.png";